import React, { useEffect, useState } from 'react';
import PromotionRender from './children/PromotionRender';
import { GAPersonalPromotionPageDisplay } from '../../../../ga/personalCenter';
import ChangePasswordModal from './children/changePasswordModal/ChangePasswordModal';
import ForgotAndResetPasswordModal from '../../../forgotPasswordModal/ForgotAndResetPasswordModal';
import FeedbackModal from './children/feedbackModal/FeedbackModal';
import ResultModal from '../../../resultModal/ResultModal';
import { useSelector } from 'react-redux';
import sentGAEvent from '../../../../ga/index';
const Promotion = () => {
  const [changePasswordModalVisible, setChangePasswordModalVisible] =
    useState(false); //是否显示修改密码弹窗
  const [forgotPasswordModalVisible, setForgotPasswordModalVisible] =
    useState(false); //忘记密码弹窗控制显示变量

  useState(false); //修改editor主题弹窗
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false); //用户反馈弹窗
  const [resultModalObj, setResultModalObj] = useState({}); //结果弹窗参数
  const reducerData = useSelector((state) => state.account.profileObj);
  useEffect(() => {
    sentGAEvent({
      category: 'EnterPage',
      action: 'V2_EnterPage',
      label: 'V2AccountPage',
    });
    GAPersonalPromotionPageDisplay();
  }, []);
  /**
   * 控制修改密码弹窗的显示和关闭
   * @param {boolean} feedbackModalVisible 是否显示修改密码弹窗
   */
  const handleFeedbackModalVisible = (feedbackModalVisible) => {
    if (feedbackModalVisible) {
      document.documentElement.style = 'position: fixed;overflow: hidden;';
    } else {
      document.documentElement.style = '';
    }
    setFeedbackModalVisible(feedbackModalVisible);
  };

  /**
   * 控制修改密码弹窗的显示和关闭
   * @param {boolean} changePasswordModalVisible 是否显示修改密码弹窗
   */
  const handleChangePasswordModalVisible = (changePasswordModalVisible) => {
    setChangePasswordModalVisible(changePasswordModalVisible);
  };

  /**
   * 忘记密码弹窗的显示和关闭
   * @param {boolean} forgotPasswordModalVisible 是否显示修改密码弹窗
   */
  const handleForgetPasswordModalVisible = (forgotPasswordModalVisible) => {
    setForgotPasswordModalVisible(forgotPasswordModalVisible);
  };

  /**
   *修改结果弹窗的值
   * @param {object} resultModalObj
   */
  const handleChangeResultObj = (resultModalObj) => {
    setResultModalObj(resultModalObj);
  };
  return (
    <>
      <PromotionRender
        changePassword={handleChangePasswordModalVisible}
        handleFeedback={handleFeedbackModalVisible}
      />

      {changePasswordModalVisible && (
        <ChangePasswordModal
          visible={changePasswordModalVisible}
          handleVisible={handleChangePasswordModalVisible}
          handleForgetPasswordModalVisible={handleForgetPasswordModalVisible}
        />
      )}
      {forgotPasswordModalVisible && (
        <ForgotAndResetPasswordModal
          visible={forgotPasswordModalVisible}
          handleVisible={handleForgetPasswordModalVisible}
        />
      )}

      {feedbackModalVisible && reducerData ? (
        <FeedbackModal
          visible={feedbackModalVisible}
          handleVisible={handleFeedbackModalVisible}
          handleChangeResultObj={handleChangeResultObj}
          email={reducerData.email}
        />
      ) : null}
      {resultModalObj.visible && (
        <ResultModal
          {...resultModalObj}
          onClose={() => setResultModalObj({})}
        />
      )}
    </>
  );
};

export default Promotion;
